import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

type PublicPlayer = Schema["TournamentPlayerPublicResponse"];

export function useTournamentPlayers(tournamentId: string | undefined) {
  return useQuery<PublicPlayer[]>({
    queryKey: queryKeys.tournaments.players(tournamentId ?? ""),
    queryFn: () => tournamentApi.listPublicPlayers(tournamentId as string),
    enabled: Boolean(tournamentId),
  });
}
